import * as yup from "yup";

import * as MESSAGES from "../messages";

export const createModelSchema = yup.object().shape({
  name: yup.string().required(MESSAGES.REQUIRE_MESSAGE).trim(),
  is_time_granularity_editable: yup.boolean(),
});
